/*eslint-disable*/
/* eslint-disable react/prop-types */
/* eslint-disable quotes */
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import { FirebaseContext } from "common";
import GridContainer from "components/Grid/GridContainer.js";
import ForwardIcon from "@material-ui/icons/Forward";
import EditIcon from "@material-ui/icons/Edit";

import CustomDropDownPicker from "./CustomDropDownPicker";

import PublishIcon from "@material-ui/icons/Publish";

import { AddBoxRounded, ArrowUpwardRounded } from "@material-ui/icons";
import GridItem from "components/Grid/GridItem.js";
import { features, language, offices, regions } from "config";
import { Grid, Typography } from "@material-ui/core";

import moment from "moment";
import {
  Row,
  Col,
  CardImg,
  Label,
  CardBody,
  Card,
  CardHeader,
  CardTitle,
  FormGroup,
  Input,
  FormText,
  Button,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";

import FlatList from "flatlist-react";
import { makeStyles } from "@material-ui/core";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import GoogleMapsAutoComplete from "components/GoogleMapsAutoComplete";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    border: "5px solid",
    borderColor: "#399ddb",
    // borderBlockStartColor: "#ff0000",
    // borderBlockStart: "2px solid",
    // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  Button: {
    width: 150,
    height: 40,
  },
  ImgContainer: {
    borderRadius: "50",
    height: "75%",
    width: "100%",
    aspectRatio: "16/9",
  },
  Card: {
    width: "50%",
    padding: 10,
    minWidth: 275,
    border: "1px solid",
    borderColor: "#399ddb",
    borderRadius: 30,
  },
  ImgCard: {
    width: "90%",
    border: "1px solid",
    borderColor: "#399ddb",
    borderRadius: 30,
  },
  PriceText: { margin: "20px0 15px", color: "#FF0000", fontSize: 32 },
  propType: {
    margin: "20px0 15px",
    fontSize: 16,
    color: "grey",
  },
  detialsSmokey: {
    width: "100%",
    alignContent: "center",
    flexDirection: "row",
    height: 25,
    backgroundColor: "#dcdcdc",
    display: "flex",
    flexDirection: "row",
  },
  detials: {
    width: "100%",
    alignContent: "center",
    flexDirection: "row",
    height: 25,
    display: "flex",
    flexDirection: "row",
  },
  CardHeader: {
    flexDirection: "column",
    fontSize: 18,
    fontWeight: "400",
    color: "#FF0000",
    display: "flex",
    margin: 15,
  },
  separator: {
    height: 1,
    width: "100%",
    backgroundColor: "#FF0000",
    alignSelf: "center",
    marginBottom: 15,
  },
  InfoDescriptionText: {
    width: "50%",
    color: "#003366",
    flexDirection: "row",
    fontSize: 15,
    fontWeight: "700",
    marginBottom: 0,
  },
  InfoText: {
    color: "#003366",
    flexDirection: "row",
    fontSize: 15,
    fontWeight: "300",
    marginBottom: 0,
  },
  radioButton: {
    marginLeft: 25,
    borderColor: "#009ad8",
    borderWidth: 2,
    height: 25,
    width: 25,
    marginTop: -4,
    marginRight: 5,
  },
  details: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    borderWidth: 2,
    borderColor: "#f00000",
    height: 40,
    backgroundColor: "white",
    fontSize: 16,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 8,
    color: "grey",
    paddingRight: 30,
  },

  checkinput: {
    marginLeft: 25,
    borderColor: "#009ad8",
    borderWidth: 2,
    borderRadius: 8,
    height: 25,
    width: 25,
    marginTop: -0.5,
    marginRight: 5,
  },

  descriptioninput: {
    borderWidth: 400,
    borderColor: "#f00000",
    height: 250,
    backgroundColor: "white",
    fontSize: 16,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 8,
    color: "grey",
    paddingRight: 30,
  },

  content: {
    flex: "1 0 auto",
  },
  cover: {
    width: 151,
  },
});

export default function CreateEnquiryDashboardModal() {
  const styles = useStyles();
  const dispatch = useDispatch();
  const { api } = useContext(FirebaseContext);
  const { CreateEnquiry, fetchCoordsfromPlace, clearEnquiryErrors } = api;

  //useStates
  const [isOpen, setIsOpen] = useState(false);
  const [brokerList, setBrokerList] = useState([]);
  const [filterstate, setFilterState] = useState({
    startDate: "",
    endDate: "",
    sizeRangeMin: "",
    sizeRangeMax: "",
    type: "",
    Proptype: "",
    Broker: "",
  });

  //regex
  const phoneRegex =
    /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  const numberRegex =
    /^(?:-(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))|(?:0|(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))))(?:.\d+|)$/;
  const typeRegex = /^[a-zA-Z0-9\\,\\.\s]/g;

  //useSelectors
  const auth = useSelector((state) => state.auth);
  const brokers = useSelector((state) => state.brokers.users);

  const toggleTwo = () => setIsOpen(!isOpen);

  const [state, setState] = useState({
    sizeRangeMin: "",
    sizeRangeMax: "",
    address: {
      suburb: "",
      streetNumber: "",
      streetName: "",
      unitNumber: "",
      complexName: "",
      floorNumber: "",
      buildingName: "",
    },
    shareBrokers: [],
    clientName: "",
    businessName: "",
    contactNumber: "",
    email: "",
    typeOfProperty: null,
    additionalNotes: "",
    type: null,
    share: auth?.info?.profile?.adminHomeOffice,
    shareType: "office",
    privacy: false,
    source: null,
    isThreePhase: false,
    currentRequirementValue: 40,
    other: "",
    OwnerBroker: "",
  });

  const RenderEnquiryInfoCard = () => {
    return (
      <Card
        style={{
          backgroundColor: "#399ddb",
          width: "95%",
          height: "100%",
        }}
      >
        <CardHeader>
          <CardTitle tag="h4" style={{ color: "white" }}>
            Enquiry Details
          </CardTitle>
        </CardHeader>
        <CardBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Size Min:
                </FormText>
                <Input
                  fullWidth
                  type="number"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    height: 35,
                    backgroundColor: "white",
                    fontSize: 16,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    borderRadius: 8,
                    color: "grey",
                    paddingRight: 30,
                  }}
                  placeholder="min size"
                  onChange={(value) => {
                    saveData("sizeRangeMin", value.target.value);
                  }}
                  value={state.sizeRangeMin}
                />
              </GridItem>
              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Size Max :
                </FormText>
                <Input
                  fullWidth
                  type="number"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    height: 35,
                    backgroundColor: "white",
                    fontSize: 16,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    borderRadius: 8,
                    color: "grey",
                    paddingRight: 30,
                  }}
                  placeholder="max size"
                  onChange={(value) => {
                    saveData("sizeRangeMax", value.target.value);
                  }}
                  value={state.sizeRangeMax}
                />
              </GridItem>

              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Brokers Areas:
                </FormText>

                {brokerList && brokerList.length > 0 ? (
                  <CustomDropDownPicker
                    options={brokerList}
                    isMulti={true}
                    onChange={(selectedBrokers) => {
                      saveData("shareBrokers", selectedBrokers)
                    }}
                  />
                ) : (
                  <FormText color="grey">No brokers available</FormText> // Fallback if no brokers
                )}
              </GridItem>

              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Owner of Enquiry:
                </FormText>

                {brokerList && brokerList.length > 0 ? (
                  <Input
                    fullWidth
                    type="select"
                    style={{
                      borderWidth: 2,
                      borderColor: "#f00000",
                      backgroundColor: "white",
                      color: "grey",
                    }}
                    value={state.OwnerBroker}
                    onChange={(e) => {
                      saveData("OwnerBroker", e.target.value);
                    }}
                  >
                    <option value="" disabled>
                      Select a Broker
                    </option>
                    {brokerList.map((broker) => (
                      <option key={broker.value} value={broker.value}>
                        {broker.label}
                      </option>
                    ))}
                  </Input>
                ) : (
                  <FormText color="grey">No brokers available</FormText> // Fallback if no brokers
                )}
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Property Type :
                </FormText>
                <Input
                  fullWidth
                  type="select"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    backgroundColor: "white",
                    color: "grey",
                  }}
                  placeholder="Select an item..."
                  onChange={(value) => {
                    saveData("typeOfProperty", value.target.value);
                  }}
                  value={state.typeOfProperty}
                >
                  <option value="" disabled></option>
                    Select a Property Type
                  <option>Warehouse</option>
                  <option>Workshop</option>
                  <option>Mini Factory</option>
                  <option>Factory</option>
                  <option>Storage Unit</option>
                  <option>Investment</option>
                  <option>Industrial Yard</option>
                  <option>Vacant Land</option>
                  <option>Showroom</option>
                  <option>Retail</option>
                  <option>Office</option>
                  <option>Restaurant</option>
                  <option>Hotel</option>
                  <option>Guesthouse</option>
                  <option>Medical Suite</option>
                  <option>Business Centre</option>
                  <option>Service Station</option>
                  <option>Small Holding</option>
                  <option>Full Floor</option>
                  <option>Business</option>
                  <option>Building</option>
                </Input>
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Source of enquiry:
                </FormText>
                <Input
                  fullWidth
                  type="select"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    backgroundColor: "white",
                    color: "grey",
                  }}
                  placeholder="Select an item..."
                  onChange={(value) => {
                    saveData("source", value.target.value);
                  }}
                  value={state.source}
                >
                  <option value="" disabled>
                    Select a Source
                  </option>
                  <option>Online enquiry</option>
                  <option>Canvassing</option>
                  <option>Board</option>
                  <option>Other</option>
                </Input>
              </GridItem>

              <GridItem xs={12}>
                <FormGroup>
                  <FormText color="white" tag="span">
                    Type:
                  </FormText>
                  <Label
                    check
                    className={styles.radioText}
                    style={{ color: "white", marginTop: 40 }}
                  >
                    <Input
                      type="radio"
                      name="radio1"
                      className={styles.radioButton}
                      onChange={() => saveData("type", "sale")}
                    />
                    Sale
                  </Label>
                  <Label
                    check
                    className={styles.radioText}
                    style={{ color: "white" }}
                  >
                    <Input
                      type="radio"
                      name="radio1"
                      className={styles.radioButton}
                      onChange={() => saveData("type", "To Let")}
                    />
                    To Let
                  </Label>
                  <Label
                    check
                    className={styles.radioText}
                    style={{ color: "white", alignItems: "center" }}
                  >
                    <Input
                      type="radio"
                      name="radio1"
                      className={styles.radioButton}
                      onChange={() => saveData("type", "both")}
                    />
                    Both
                  </Label>
                </FormGroup>
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span"></FormText>
                <label
                  style={{
                    fontSize: 15,
                    fontWeight: "400",

                    color: "white",
                  }}
                >
                  {" "}
                  Notes:
                  <textarea
                    name="description"
                    value={state?.additionalNotes}
                    rows={10}
                    cols={55}
                    required
                    onChange={(value) => {
                      value.preventDefault();
                      saveData("additionalNotes", value.target.value);
                    }}
                    style={{
                      fontSize: 15,
                      fontWeight: "400",
                      border: "1px solid",
                      borderColor: "#399ddb",
                      color: "#0b042e",
                      height: "200px",
                    }}
                  />
                </label>
                {/* <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("additionalNotes", value.target.value);
                  }}
                  value={state.additionalNotes}
                  fullWidth
                  type="textarea"
                  className={styles.descriptioninput}
                /> */}
              </GridItem>
            </GridContainer>
          </GridItem>
        </CardBody>
      </Card>
    );
  };

  const RenderShareCard = () => {
    return (
      <Card
        style={{
          backgroundColor: "#399ddb",
          width: "95%",
          height: "53%",
        }}
      >
        <CardHeader>
          <CardTitle tag="h4" style={{ color: "white" }}>
            Enquiry Shared Details
          </CardTitle>
        </CardHeader>
        <CardBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem xs={6}>
                <Label
                  check
                  className={styles.radioText}
                  style={{ color: "white", fontSize: 18 }}
                >
                  Dont Share Enquiry:
                  <Input
                    type="checkbox"
                    className={styles.checkinput}
                    onChange={(value) => {
                      saveData("privacy", !state.privacy);
                    }}
                  />
                </Label>
              </GridItem>
              {!state.privacy && (
                <>
                  {" "}
                  <GridItem xs={12}>
                    <FormGroup>
                      <Label
                        check
                        className={styles.radioText}
                        style={{ color: "white" }}
                      >
                        <Input
                          type="radio"
                          name="radio2"
                          className={styles.radioButton}
                          onChange={() => saveData("shareType", "office")}
                        />
                        My Office
                      </Label>
                      <Label
                        check
                        className={styles.radioText}
                        style={{ color: "white" }}
                      >
                        <Input
                          type="radio"
                          name="radio2"
                          className={styles.radioButton}
                          onChange={() => saveData("shareType", "province")}
                        />
                        Other Office
                      </Label>
                      <Label
                        check
                        className={styles.radioText}
                        style={{ color: "white", alignItems: "center" }}
                      >
                        <Input
                          type="radio"
                          name="radio2"
                          className={styles.radioButton}
                          onChange={() => saveData("sharetype", "national")}
                        />
                        All Offices
                      </Label>
                    </FormGroup>
                  </GridItem>
                  {state.shareType === "province" && (
                    <GridItem xs={6}>
                      <FormText color="white" tag="span">
                        Office:
                      </FormText>

                      <Input
                        fullWidth
                        type="select"
                        style={{
                          borderWidth: 2,
                          borderColor: "#f00000",
                          backgroundColor: "white",
                          color: "grey",
                        }}
                        onChange={(value) => {
                          saveData("share", value.target.value);
                        }}
                        value={state.share}
                      >
                        <option>Plum</option>
                        <option>Western Cape</option>
                        <option>Gauteng</option>
                        <option>Easter Cape</option>
                        <option>KZN</option>
                      </Input>
                    </GridItem>
                  )}
                </>
              )}
            </GridContainer>
          </GridItem>
        </CardBody>
      </Card>
    );
  };

  const RenderClientDetailsCard = () => {
    return (
      <Card
        style={{
          backgroundColor: "#399ddb",
          width: "95%",
          height: "45%",
        }}
      >
        <CardHeader>
          <CardTitle tag="h4" style={{ color: "white" }}>
            Client Details
          </CardTitle>
        </CardHeader>
        <CardBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Contact Person:
                </FormText>
                <Input
                  fullWidth
                  type="text"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    height: 35,
                    backgroundColor: "white",
                    fontSize: 16,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    borderRadius: 8,
                    color: "grey",
                    paddingRight: 30,
                  }}
                  placeholder="Name"
                  onChange={(value) => {
                    saveData("clientName", value.target.value);
                  }}
                  value={state.clientName}
                />
              </GridItem>

              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Business Name:
                </FormText>
                <Input
                  fullWidth
                  type="text"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    height: 35,
                    backgroundColor: "white",
                    fontSize: 16,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    borderRadius: 8,
                    color: "grey",
                    paddingRight: 30,
                  }}
                  placeholder="Bussiness Name"
                  onChange={(value) => {
                    saveData("businessName", value.target.value);
                  }}
                  value={state.businessName}
                />
              </GridItem>

              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Contact Number:
                </FormText>
                <Input
                  fullWidth
                  type="text"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    height: 35,
                    backgroundColor: "white",
                    fontSize: 16,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    borderRadius: 8,
                    color: "grey",
                    paddingRight: 30,
                  }}
                  placeholder="Phone Number"
                  onChange={(value) => {
                    saveData("contactNumber", value.target.value);
                  }}
                  value={state.contactNumber}
                />
              </GridItem>

              <GridItem xs={6}>
                <FormText color="white" tag="span">
                  Contact Email:
                </FormText>
                <Input
                  fullWidth
                  type="text"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    height: 35,
                    backgroundColor: "white",
                    fontSize: 16,
                    paddingHorizontal: 10,
                    paddingVertical: 8,
                    borderRadius: 8,
                    color: "grey",
                    paddingRight: 30,
                  }}
                  placeholder="Email Address"
                  onChange={(value) => {
                    saveData("email", value.target.value);
                  }}
                  value={filterstate.size}
                />
              </GridItem>
            </GridContainer>
          </GridItem>
        </CardBody>
      </Card>
    );
  };
  const RenderItem = ({ item }) => {
    return (
      <>
        <Col md="4">
          <Card
            className="card-chart"
            style={{
              height: "620px",
              minWidth: "275",
              border: "3px solid",
              borderColor: "#399ddb",
              borderRadius: 30,
            }}
          >
            <CardHeader>
              <CardTitle
                tag="h2"
                style={{
                  fontSize: 30,
                  fontWeight: "1000",
                  margin: "10px 0 0 1px",
                  color: "#f00000",
                }}
              >
                {item.type === "sale"
                  ? "Looking To Buy"
                  : item.type === "To Let"
                    ? "Looking To Rent"
                    : "Looking To Buy or Rent"}
              </CardTitle>

              <UncontrolledDropdown>
                <DropdownToggle
                  className="btn-round btn-icon"
                  color="default"
                  outline
                // style={{marginRight: spacing + 'em'}}
                >
                  <i className="now-ui-icons design_bullet-list-67" />
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem>Share</DropdownItem>
                  <DropdownItem>Update</DropdownItem>
                  <DropdownItem>Archive</DropdownItem>
                  <DropdownItem>Unachive</DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      navigate("/staffpullforward", { state: { item } });
                    }}
                  >
                    Pull Forward
                  </DropdownItem>
                  <DropdownItem>Call Client</DropdownItem>
                  <DropdownItem>Message Client</DropdownItem>
                  <DropdownItem className="text-danger">
                    Share Internally
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </CardHeader>

            <CardBody>
              <Row mb="12">
                <Col md="12">
                  <FormGroup
                    style={{
                      fontSize: 15,
                      fontWeight: "400",
                      margin: "10px 0 0 1px",
                      color: "#0b042e",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 18,
                        fontWeight: "1000",
                        margin: "10px 0 0 1px",
                        color: "#0b042e",
                      }}
                    >
                      Company:{" "}
                    </span>
                    {/* <p className="description">{Booking.serviceType}</p> */}
                    {item?.CompanyName}{" "}
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup
                    style={{
                      fontSize: 15,
                      fontWeight: "400",
                      margin: "10px 0 0 1px",
                      color: "#0b042e",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 18,
                        fontWeight: "600",
                        margin: "10px 0 0 1px",
                        color: "#0b042e",
                      }}
                    >
                      Area:{" "}
                    </span>
                    {item?.suburbs
                      ? item?.suburbs?.length > 0
                        ? `${item?.suburbs}`.substring(0, 100).trim() + `...`
                        : "N/A"
                      : "N/A"}
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup
                    style={{
                      fontSize: 15,
                      fontWeight: "400",
                      margin: "10px 0 0 1px",
                      color: "#0b042e",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 18,
                        fontWeight: "600",
                        margin: "10px 0 0 1px",
                        color: "#0b042e",
                      }}
                    >
                      Property Type:{" "}
                    </span>
                    {/* <p className="description">{Booking.eventDate}</p> */}
                    {item.typeOfProperty}{" "}
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup
                    style={{
                      fontSize: 15,
                      fontWeight: "400",
                      margin: "10px 0 0 1px",
                      color: "#0b042e",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 18,
                        fontWeight: "600",
                        margin: "10px 0 0 1px",
                        color: "#0b042e",
                      }}
                    >
                      Property Size:{" "}
                    </span>
                    {/* <p className="description">{Booking.eventDate}</p> */}
                    {item.sizeMin} - {item.sizeMax}㎡
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup
                    style={{
                      fontSize: 15,
                      fontWeight: "400",
                      margin: "10px 0 0 1px",
                      color: "#0b042e",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 18,
                        fontWeight: "600",
                        margin: "10px 0 0 1px",
                        color: "#0b042e",
                      }}
                    >
                      To Let/ For Sale:{" "}
                    </span>
                    {/* <p className="description">{Booking.eventDate}</p> */}
                    {item.type === "sale"
                      ? "Looking To Buy"
                      : item.type === "To Let"
                        ? "Looking To Rent"
                        : "Looking To Buy or Rent"}
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup
                    style={{
                      fontSize: 15,
                      fontWeight: "400",
                      margin: "10px 0 0 1px",
                      color: "#0b042e",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 18,
                        fontWeight: "600",
                        margin: "10px 0 0 1px",
                        color: "#0b042e",
                      }}
                    >
                      Notes:{" "}
                    </span>
                    {/* <p className="description">{Booking.eventDate}</p> */}
                    {item.notes}
                  </FormGroup>
                </Col>

                <Col md="12">
                  <FormGroup
                    style={{
                      fontSize: 15,
                      fontWeight: "400",
                      margin: "10px 0 0 1px",
                      color: "#0b042e",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 18,
                        fontWeight: "600",
                        margin: "10px 0 0 1px",
                        color: "#0b042e",
                      }}
                    >
                      Enquiry Date:{" "}
                    </span>
                    {/* <p className="description">{Booking.eventDate}</p> */}
                    {item.enquiryDate
                      ? moment(item.enquiryDate).format("MMMM Do YYYY HH:mm:ss")
                      : "N/A"}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <FormGroup>
                  {item?.pullforward !== "false" ? (
                    <ForwardIcon style={{ color: "#ff000f" }} />
                  ) : null}
                </FormGroup>{" "}
              </Row>
            </CardBody>
            <CardFooter>
              <Button
                color="primary"
                onClick={() => {
                  navigate("/staffenquirydetails", { state: { item } });
                }}
              >
                View
              </Button>
            </CardFooter>
          </Card>
        </Col>
      </>
    );
  };

  //functions
  const CreateEnquiries = () => {
    //Inriching Enquiry Data before sending it to the action
    // !DO NOT CHANGE WITHOUT PERMISSION FROM GAYNOR OR STEVEN!!!
    // ?last updated 17/01/2025
    let EnquiryData = {
      // ?Name of company the enquiry is created for
      CompanyName: state.businessName ? state.businessName : "",
      Email: state.email ? state.email : "",
      PhoneNumber: state.contactNumber ? state.contactNumber : "",
      OwnerName: state.clientName ? state.clientName : "",
      address: {
        suburb: state.address.suburb ? state.address.suburb : " ",
        streetNumber: state.address.streetNumber //added more address fields
          ? state.address.streetNumber
          : " ",
        streetName: state.address.streetName ? state.address.streetName : " ",
        unitNumber: state.address.unitNumber ? state.address.unitNumber : " ",
        complexName: state.address.complexName
          ? state.address.complexName
          : " ",
        floorNumber: state.address.floorNumber
          ? state.address.floorNumber
          : " ",
        buildingName: state.address.buildingName
          ? state.address.buildingName
          : " ",
      },
      selectedArea: state.address.suburb ? state.address.suburb : " ", //Added with the approval of Steven 26/09/2024 Adam
      isThreePhase: state.isThreePhase, //Added with the approval of Steven 28/09/2024 jared
      currentRequirementValue: state.currentRequirementValue
        ? state.currentRequirementValue
        : 0,
      sizeMax: state.sizeRangeMax,
      sizeMin: state.sizeRangeMin,
      status: "Active",
      source: state?.source !== "Other" ? state?.source : state?.other,
      typeOfProperty: state.typeOfProperty,
      notes: state.additionalNotes,
      type: state.type,
      share: state.share,
      pullforward: "false",
      shareType: state.shareType,
      privacy: state.privacy,
      shareBrokers: state.shareBrokers ? [...state.shareBrokers] : [],
      ownerBroker: state.OwnerBroker,
      // dates need to be normalized for mobile calendar
      markedDate: normalizedDate(new Date().toString()),
      enquiryDate: new Date().getTime(),
      office: auth?.info?.profile?.adminHomeOffice,
    };
    console.log("EnquiryDataasdas", EnquiryData);
    if (state.clientName) {
      if (phoneRegex.test(state.contactNumber) === true) {
        if (
          numberRegex.test(state.sizeRangeMin && state.sizeRangeMax) === true
        ) {
          if (typeRegex.test(state.type) === true) {
            if (
              (!state.privacy &&
                (state.shareType === "province" ||
                  state.shareType === "office") &&
                state.share !== null) ||
              state.shareType === "national" ||
              state.privacy
            ) {
              dispatch(CreateEnquiry(EnquiryData, brokers));
            } else {
              console.log(language.alert, language.share);
            }
          } else {
            console.log(language.alert, language.proper_input_sale_type);
          }
        } else {
          console.log(language.alert, language.proper_input_size);
        }
      } else {
        console.log(language.alert, language.proper_input_mobile);
      }
    } else {
      console.log(language.alert, language.proper_input_name);
    }
    // }
    // }
  };

  const saveData = (location, data) => {
    setState({
      ...state,
      [location]: data,
    });
  };

  const normalizedDate = (date) => {
    //returns date in formate of YYYY-MM-DD
    return `${moment(date).format("YYYY")}-${moment(date).format(
      "MM"
    )}-${moment(date).format("DD")}`;
  };

  //useEffects
  useEffect(() => {
    let arr = [];
    if (brokers) {
      console.log("Brokers:", brokers); // Log brokers to verify data
      for (let index = 0; index < brokers.length; index++) {
        const element = brokers[index];

        // Populate the list with all brokers, remove brokerHomeOffice filter
        if (element.brokerHomeOffice === auth?.info?.profile?.adminHomeOffice) {
          arr.push({
            value: element.id, // The broker ID (or name if preferred)
            label: `${element.firstName} ${element.lastName}`, // Broker name
          });
        }
      }
      setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
      console.log("Broker List:", arr); // Log broker list to verify population
    }
  }, [brokers]);

  const RenderModal = () => {
    return (
      <Modal isOpen={isOpen} toggle={toggleTwo} centered={true} size="xl">
        <ModalHeader>Create Enquiry</ModalHeader>
        <ModalBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem lg={6}>{RenderEnquiryInfoCard()}</GridItem>

              <GridItem lg={6}>
                {RenderClientDetailsCard()}

                {RenderShareCard()}
              </GridItem>
            </GridContainer>
          </GridItem>
        </ModalBody>

        <ModalFooter>
          <Button onClick={CreateEnquiries}>Create Enquiry</Button>

          <Button
            style={{
              backgroundColor: "#ff000f",
              height: 45,
            }}
            onClick={toggleTwo}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  return (
    <>
      <AddBoxRounded
        onClick={toggleTwo}
        style={{
          color: "#ff000f",
          alignItems: "right",
          width: 50,
          height: 50,
          cursor: "pointer",
        }}
      />
      {RenderModal()}
    </>
  );
}
